export const FeeType = Object.freeze({
	PRINT: 'PRINT',
	EXTRA_SERVICE: 'EXTRA_SERVICE',
	SURCHARGE: 'SURCHARGE',
	OTHER: 'OTHER',
});

export const CostDetails = Object.freeze({
	[FeeType.PRINT]: {
		SHIPPING_LABEL: 'shipping_label_fee',
		MAILING_LABEL: 'mailing_label_fee',
		EXTRA_SERVICE: 'extra_service_fee',
		MEDIA_MAIL: 'media_mail_fee',
	},

	[FeeType.EXTRA_SERVICE]: {
		NON_MACHINABLE: 'non_machinable',
		SATURDAY_DELIVERY: 'saturday_delivery',
		CERTIFIED_MAIL: 'certified_mail',
		RETURN_RECEIPT: 'return_receipt',
		RETURN_RECEIPT_ELECTRONIC: 'return_receipt_electronic',
		SUNDAY_OR_HOLIDAY_DELIVERY: 'sunday_or_holiday_delivery',
		RESTRICTED_DELIVERY: 'restricted_delivery',
		NOTICE_OF_NON_DELIVERY: 'notice_of_non_delivery',
		PAY_ON_USE: 'pay_on_use',
		REGISTERED_MAIL: 'registered_mail',
		COLLECT_ON_DELIVERY: 'collect_on_delivery',
		SPECIAL_HANDLING: 'special_handling_amount',
		NO_LABEL: 'no_label',
		USPS_NONSTANDARD_PACKAGE_CHARACTERISTICS:
			'usps_nonstandard_package_characteristics',
	},

	[FeeType.OTHER]: {
		DELIVERED_DUTY_PAID: 'delivered_duty_paid',
		NON_MACHINABLE: 'non_machinable',
		SATURDAY_DELIVERY: 'saturday_delivery',
		HOLD_FOR_PICKUP: 'hold_for_pickup',
		CERTIFIED_MAIL: 'certified_mail',
		RETURN_RECEIPT: 'return_receipt',
		RETURN_RECEIPT_ELECTRONIC: 'return_receipt_electronic',
		COLLECT_ON_DELIVERY: 'collect_on_delivery',
		REGISTERED_MAIL: 'registered_mail',
		SUNDAY_OR_HOLIDAY_DELIVERY: 'sunday_or_holiday_delivery',
		RESTRICTED_DELIVERY: 'restricted_delivery',
		NOTICE_OF_NON_DELIVERY: 'notice_of_non_delivery',
		HAZARDOUS_MATERIALS: 'hazardous_materials',
		PERISHABLES: 'perishables',
		CREMATED_REMAINS: 'cremated_remains',
		LIVE_ANIMALS: 'live_animals',
		LIVE_ANIMALS_WITH_FEE: 'live_animals_with_fee',
		FRAGILE: 'fragile',
		NO_LABEL: 'no_label',
		PAY_ON_USE: 'pay_on_use',
	},
});
